import { makeStyles, MenuItem } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';


const useStyles = makeStyles((theme) => ({
    root: {},
}));


const DropdownItem = ({ className, children, ascent, onClick, ...props }) => {

    const classes = useStyles({ ascent });

    return (
        <MenuItem  onClick={onClick} className={clsx(classes.root, className)} {...props}>{children}</MenuItem>
    );
};

DropdownItem.propTypes = {
    className: PropTypes.string,
    ascent: PropTypes.string,
    onClick: PropTypes.func
};

export default DropdownItem;